export const DATA_KEYS = {
  title: "props.title",
  hasCustomTitle: "props.hasCustomTitle",
  dimensions: "props.dimensions",
  // Event flow mode
  mode: "props.mode",
  eventFlowConfig: "props.eventFlowConfig",
  efEventNameField: "props.eventFlowConfig.eventNameField",
  efIdField: "props.eventFlowConfig.idField",
  efOrderByMode: "props.eventFlowConfig.orderByMode",
  efOrderField: "props.eventFlowConfig.orderField",
  efTimeField: "props.eventFlowConfig.timeField",
  // Event flow visibility
  efVisibilityPreset: "props.efVisibilityPreset",
  efHiddenEventsPerStep: "props.efHiddenEventsPerStep",
};
